<template>
	<div class="contact-container">
		<div class="contact-container-overflow">
			<form class="contact-form" @submit.prevent="addPlaceOfLoading">
				<div class="sp-3 flex ai-c jc-sb">
					<h4>Informações do Local de Embarque</h4>
					<p style="margin-bottom: 0">Os campos marcados com <span class="tx-danger">*</span> são obrigatórios.</p>
				</div>
				<div>
					<v-input
						name="name"
						type="text"
						label="Nome do Local de Embarque"
						v-model="placeOfLoading.name"
						:requiredFlag="true"
						:class="{'input-danger': getError('name') }"
					/>
					<div class="field-error">
						{{ getError('name') }}
					</div>
				</div>
				<div>
					<select-wrapper v-model="placeOfLoading.type" :options="typeOptions" label="Tipo" :requiredFlag="true" :class="{'input-danger': getError('type') }"/>
					<div class="field-error">
						{{ getError('type') }}
					</div>
				</div>
				<div></div>
				<div>
					<v-input name="codeRfb" type="text" label="Código RFB" v-model="placeOfLoading.codeRfb"/>
				</div>
				<div>
					<v-input name="codeIso" type="text" label="Código ISO" v-model="placeOfLoading.codeIso"/>
				</div>
				<div>
					<v-input name="unlocode" type="text" label="UN/LOCODE" v-model="placeOfLoading.unlocode"/>
				</div>
				<div class="sp-3 mt-3 bd-t pd-t-10">
					<h4>Endereço</h4>
				</div>
				<div>
					<v-input name="state" type="text" label="Estado" v-model="placeOfLoading.address.state"/>
				</div>
				<div>
					<v-input name="city" type="text" label="Cidade" v-model="placeOfLoading.address.city" :requiredFlag="true" :class="{'input-danger': getError('address.city') }"/>
					<div class="field-error">
						{{ getError('address.city') }}
					</div>
				</div>
				<div>
					<v-input name="countryName" type="text" label="País" v-model="placeOfLoading.address.countryName" :requiredFlag="true" :class="{'input-danger': getError('address.countryName') }"/>
					<div class="field-error">
						{{ getError('address.countryName') }}
					</div>
				</div>
				<div class="sp-3 row justify-content-center mt-4 gap-2">
					<button type="button" class="crm-button red mr-4" @click="$emit('cancel')">Cancelar</button>
					<button type="submit" class="report-button">Salvar</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import * as yup from "yup";
import config from "@/config.js";
import Axios from "axios";
import Swal from "sweetalert2";
import SelectWrapper from "@/components/SelectWrapper.vue";
import VInput from "@/components/VInput.vue";

export default {
	name: "AddPlaceOfLoading",
	components: {
		SelectWrapper,
		VInput,
	},
	props: {
		placeOfLoadingData: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			fieldErrors: [],
			placeOfLoading: { ...this.placeOfLoadingData },
			typeOptions: [
				{
					label: "Porto",
					value: "SEAPORT",
				},
				{
					label: "Aéroporto",
					value: "AIRPORT",
				},
				{
					label: "Fronteira",
					value: "BORDER",
				}
			]
		};
	},
	computed: {},
	mounted() {},
	methods: {
		getError(path) {
			const err = this.fieldErrors.find((e) => e.path === path);
			if (err) {
				return err.message;
			}
			return '';	
		},
		async addPlaceOfLoading() {
			this.fieldErrors = [];
			try {

				let schema = yup.object().shape({
					name: yup.string().required('O Nome do Local de Embarque é obrigatório'),
					type: yup.string().required('O Tipo é obrigatório'),
					address: yup.object().shape({
						city: yup.string().required('A Cidade é obrigatória'),
						countryName: yup.string().required('O País é obrigatório'),
					}),
				});

				await schema.validate(this.placeOfLoading, {
					abortEarly: false,
				});

				const response = await Axios.post(`${config.env.API_DEFAULT.host}/places`, this.placeOfLoading);

				let newPlaceOfLoading = {
					...response.data.data,
					_links: {
						self: {
							href: `${config.env.API_DEFAULT.host}/places/${response.data.data.id}`,
						},
					},
				};
				this.$emit('finish', newPlaceOfLoading);
			} catch (error) {
				if (error.name == "ValidationError") {
					this.fieldErrors = error.inner;
					console.log(this.fieldErrors);
					let html = '<div class="text-left pl-4 pr-4 pt-4"><p>Por favor, preencha os campos obrigatórios abaixo!</p>';
					if (error.errors.length > 0) {
						html += '<ul>';
						error.errors.forEach(error => {
							html += `<li class="mb-2">${error}</li>`
						})
						html += '</ul>';
					}
					html += '</div>';
				
					Swal.fire({
						title: 'Adicionar Local de Embarque',
						html: html,
						type: 'error',
						customClass: 'alert-error'
					});
				} else {
					console.log(error);
					let message = error.response.data?.data || error.response.data?.message;
					if (!message) {
						message = 'Não foi possível adicionar o local de embarque';
					}
					Swal.fire({
						title: "Adicionar Local de Embarque",
						html: `<p>${message}</p>`,
						type: "error",
					});
				}
			}
		},
	},
};
</script>

<style scoped>
.report-button {
  --webkit-appearance: none;
  --moz-appearance: none;
  outline: none;
  --webkit-outline: none;
  --moz-outline: none;
  border: 0;
  background-color: #104375;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  border-radius: 2px;
  color: white;
  padding: 10px 35px;
  border-radius: 10px;
  text-transform: uppercase;
  transition: all 0.2s ease-in-out 0s;
  font-size: 1rem;
}

.report-button:hover {
  background-color: #1768a7;
}
.contact-container {
	height: auto !important;
}
</style>

<style>
.alert-error {
	width: 500px !important;
}
</style>